<template>
  <div class="header">
    <HeaderMeta />
    <HeaderLogos />
    <HeaderMenu />
    <HeaderBanner />
  </div>
</template>

<script>
import HeaderMeta from './HeaderMeta';
import HeaderLogos from './HeaderLogos';
import HeaderMenu from './HeaderMenu';
import HeaderBanner from './HeaderBanner';


export default {
    name: 'Header',
    components: { HeaderMeta, HeaderLogos, HeaderMenu, HeaderBanner },
};
</script>

<style scoped>
.header {
  width: 100%;
}
</style>
